import AssessmentsPage from './Assessments';
export { default as AddAssessment } from './AddAssessment';

export default AssessmentsPage;
